import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { FamiliarSection } from '../components/FamiliarSection';
import { IdentificationSection } from '../components/IdentificationSection';
import { MechanismSection } from '../components/MechanismSection';
import { WhyNothingWorksSection } from '../components/WhyNothingWorksSection';
import { MethodSection } from '../components/MethodSection';
import { WhatChangesSection } from '../components/WhatChangesSection';
import { ObjectionsSection } from '../components/ObjectionsSection';
import { FinalOfferSection } from '../components/FinalOfferSection';
export function LandingPage() {
  return <main className="w-full" data-id="element-229">
      <HeroSection data-id="element-230" />
      <FamiliarSection data-id="element-231" />
      <IdentificationSection data-id="element-232" />
      <MechanismSection data-id="element-233" />
      <WhyNothingWorksSection data-id="element-234" />
      <MethodSection data-id="element-235" />
      <WhatChangesSection data-id="element-236" />
      <ObjectionsSection data-id="element-237" />
      <FinalOfferSection data-id="element-238" />
    </main>;
}